function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import { withRouter } from 'react-router-dom';
import * as Sentry from '@sentry/react';
import { CustomModal } from 'seagull';
import GenericError from "../GenericError/GenericError";

class ErrorBoundaryPage extends React.Component {
  constructor() {
    super(...arguments);

    _defineProperty(this, "state", {
      hasError: false
    });
  }

  static getDerivedStateFromError() {
    return {
      hasError: true
    };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.location.pathname !== this.props.location.pathname || prevProps.location.search !== this.props.location.search) {
      this.setState({
        hasError: false
      });
    }
  }

  componentDidCatch(error) {
    console.error(error);
    Sentry.captureException(error);
  }

  render() {
    const {
      bounded,
      isModal,
      children,
      dismissModal
    } = this.props;
    const {
      hasError
    } = this.state;
    const errorPage = /*#__PURE__*/React.createElement(GenericError, {
      fullPage: !bounded && !isModal,
      testid: "error-boundary-page"
    });
    return hasError ? isModal ? /*#__PURE__*/React.createElement(CustomModal, {
      onClose: dismissModal
    }, errorPage) : errorPage : children;
  }

}

export default withRouter(ErrorBoundaryPage);